<template>
  <v-container fluid class="pa-0 ma-0">
    <Contato v-if="cliente" />
    <v-card v-else flat color="#F7F7F7">
      <v-img
        class="mt-10"
        src="@/assets/fundowhats.jpeg"
        aspect-ratio="2"
        contain
        max-height="100%"
      ></v-img>
      <h5 style="text-align: center; color: #666">Xcontact Omni Channel</h5>
      <p style="text-align: center !important; color: #666">
        {{ t("fraseInicial") }}
      </p>
    </v-card>
  </v-container>
</template>

<script>
import Contato from "../components/Cliente";
import { mapState } from "vuex";
export default {
  components: {
    Contato,
  },
  data: () => ({
    tab: null,
  }),
  computed: {
    ...mapState("xc", {
      cliente: (state) => state.cliente,
    }),
  },
};
</script>